import { Document, DocumentFilter } from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

export const MAX_FILE_SIZE = 512 * 1024 * 1024; // 512 MB
export const MAX_FILES = 5;
export const SUPPORTED_FORMATS = [
    'TXT',
    'MARKDOWN',
    'MDX',
    'PDF',
    'HTML',
    'XLSX',
    'XLS',
    'DOCX',
    'CSV',
    'VTT',
    'PROPERTIES',
    'MD',
    'HTM'
];

export class DocumentModel extends TableModel<Document, DocumentFilter> {
    baseURI = 'document';
    client = userStore.client;
}

export default new DocumentModel();
